import { render } from "./addNotice.vue?vue&type=template&id=4e3ca274"
import script from "./addNotice.vue?vue&type=script&lang=js"
export * from "./addNotice.vue?vue&type=script&lang=js"

import "./addNotice.vue?vue&type=style&index=0&id=4e3ca274&lang=css"
script.render = render

export default script